import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getStoredUser } from '../utils/auth';

function Navigation() {
  const location = useLocation();
  const user = getStoredUser();

  const isActive = (path) => location.pathname === path;

  if (user && location.pathname === '/dashboard') {
    return null;
  }

  return (
    <nav className="bg-black shadow-md sticky top-0 z-50 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0">
            <Link
              to="/"
              onClick={() => {
                if (location.pathname === '/') {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}
              className="flex items-center text-white hover:opacity-90 transition-opacity"
              aria-label="CSO Site Safety Services Inc"
            >
              <img
                src="/logo-1.png"
                alt="CSO Site Safety Services Inc"
                className="h-14 w-auto"
              />
            </Link>
          </div>
          <ul className="flex space-x-4 md:space-x-8">
            <li>
              <Link
                to="/"
                className={`px-3 py-2 rounded-md text-lg font-medium transition-colors ${
                  isActive('/')
                    ? 'bg-gray-800 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-gray-800'
                }`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={`px-3 py-2 rounded-md text-lg font-medium transition-colors ${
                  isActive('/about')
                    ? 'bg-gray-800 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-gray-800'
                }`}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                to="/login"
                className={`px-3 py-2 rounded-md text-lg font-medium transition-colors ${
                  isActive('/login')
                    ? 'bg-gray-800 text-white'
                    : 'text-gray-300 hover:text-white hover:bg-gray-800'
                }`}
              >
                Login
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
